import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon } from 'lucide-react';
export const TutorialVideoSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const element = document.getElementById('tutorial-video');
      if (element) {
        const position = element.getBoundingClientRect();
        if (position.top < window.innerHeight * 0.85) {
          setIsVisible(true);
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check on initial load
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <section id="tutorial-video" className="py-16 md:py-24 bg-gray-50" data-id="element-12462">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-12463">
        <div className="text-center mb-10" data-id="element-12464">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy-900 mb-4" data-id="element-12465">
            See MaestroConnect in Action
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-12466">
            Watch the full platform walkthrough and see how to manage students,
            lessons, tasks, reports, sheet music, and revenue — all in one
            place.
          </p>
        </div>

        <div className={`max-w-[900px] mx-auto transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-12467">
          {/* Responsive 16:9 Video Container */}
          <div className="relative w-full overflow-hidden rounded-xl shadow-lg border border-gray-200 bg-black" style={{
          paddingTop: '56.25%'
        }} data-id="element-12468">
            <iframe className="absolute top-0 left-0 w-full h-full" src="https://www.youtube.com/embed/WENnqXSm9oA?si=anwCF01qvosSY9fX" title="MaestroConnect Platform Walkthrough" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen data-id="element-12469"></iframe>
          </div>

          {/* CTA Button */}
          <div className="mt-10 flex justify-center" data-id="element-12470">
            <Link to="/teacher-signup" className="bg-deep-pink hover:bg-[#8b1e3f] text-white px-8 py-4 rounded-lg font-medium text-lg flex items-center transition-colors shadow-md hover:shadow-lg" onClick={() => {
            window.scrollTo(0, 0);
          }} data-id="element-12471">
              Start Free Beta
              <ChevronRightIcon className="ml-2 h-5 w-5" data-id="element-12472" />
            </Link>
          </div>
        </div>
      </div>
    </section>;
};